// extracted by mini-css-extract-plugin
module.exports = {"planQuestionSet":"PlanQuestionSet_planQuestionSet__3Qh6-","title":"PlanQuestionSet_title__2XwZP"};